import { PERMISSIONS } from '../../constants';
import edit from './SettingEdit';

export default {
  list: edit,
  name: 'settings',
  permissions: [PERMISSIONS.SETTINGS],
  options: { label: 'Configurações' },
};